import NavigationBar from './NavigationBar'

function Wrapper(props) {
  return (
    <div>
        <NavigationBar />
        <title>{ props.title }</title>
        <div className="app-body">
          { props.children }
        </div>
    </div>
  )
}

export default Wrapper